// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__JbyPD","modal":"Modal_modal__+EjPb","slide-down":"Modal_slide-down__6a0A1"};